import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/shared/material/material.module';

export type DisableUserConfirmData = {
  email: string;
};

@Component({
  selector: 'app-disable-user-confirm-dialog',
  standalone: true,
  imports: [MaterialModule, MatDialogModule],
  templateUrl: './disable-user-confirm-dialog.component.html',
})
export class DisableUserConfirmDialogComponent {
  #dialogRef = inject(MatDialogRef<DisableUserConfirmDialogComponent, boolean>);
  data: DisableUserConfirmData = inject(MAT_DIALOG_DATA);

  onConfirm(): void {
    this.#dialogRef.close(true);
  }
}
